import DocumentCard from '@pages/Inspections/components/RightPanelCards/DocumentCard';
import NevdisCheckCard from '@pages/Inspections/components/RightPanelCards/NevdisCheckCard';
import { DocumentFormEnum, DocumentFormType } from '@types';
import { useInspectionDetailStore } from '@stores';
import { SECURITY_CHECK_LIST } from '@constants';
import SalePriceCard from '@pages/Inspections/components/RightPanelCards/SalePriceCard';
import {
  getInspectionCheckDocument,
  resolveSecurityCheckStatus,
  resolveVehicleDataEditsStatus
} from '../../utils/securityCheckHandlers';

const VehicleDetails = () => {
  const { activePanel, inspectionDetailData } = useInspectionDetailStore();
  const activeSection = activePanel.activeSection;
  const inspectionChecks = inspectionDetailData.inspectionChecks;
  const securityCheckDocument = getInspectionCheckDocument(
    inspectionChecks,
    activeSection,
    '2',
    inspectionDetailData.assetType
  );
  const isVinMismatch =
    activeSection === 'vin' &&
    [
      inspectionChecks?.vin?.licencePlateMatch,
      inspectionChecks?.licencePlate?.vinMatch
    ].includes('DIFFERENT');
  const securityCheckStatus =
    activeSection === 'dataEdits'
      ? resolveVehicleDataEditsStatus(inspectionChecks)
      : resolveSecurityCheckStatus(
          securityCheckDocument,
          securityCheckDocument?.type,
          inspectionChecks,
          activeSection,
          isVinMismatch
        );
  const securityCheckData =
    activeSection === 'vin' || activeSection === 'dataEdits'
      ? inspectionChecks
      : securityCheckDocument;

  return (
    <>
      {activePanel.activeSection === 'VIN' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_VIN} />
      )}
      {activePanel.activeSection === 'MARINE_HIN' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_HIN} />
      )}
      {activePanel.activeSection === 'MARINE_REGO_NUMBER' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_REGO_NUMBER} />
      )}
      {activePanel.activeSection === 'MARINE_REGO_CERT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_REGO_CERT} />
      )}
      {activePanel.activeSection === 'REGO_PLATE' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_PLATE} />
      )}
      {activePanel.activeSection === 'ODOMETER' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_ODOMETER} />
      )}
      {activePanel.activeSection === 'ASSET_FRONT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_ASSET_FRONT} />
      )}
      {activePanel.activeSection === 'ASSET_BACK' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_ASSET_BACK} />
      )}
      {activePanel.activeSection === 'ASSET_RIGHT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_DRIVER_SIDE} />
      )}
      {activePanel.activeSection === 'ASSET_LEFT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_PASSENGER_SIDE} />
      )}
      {activePanel.activeSection === 'INTERNAL_FRONT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_FRONT} />
      )}
      {activePanel.activeSection === 'INTERNAL_BACK' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_BACK} />
      )}
      {activePanel.activeSection === 'INTERNAL_BOOT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_BOOT} />
      )}
      {activePanel.activeSection === 'INTERNAL_LIVING_AREA' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_LIVING_AREA} />
      )}
      {activePanel.activeSection === 'INTERNAL_KITCHEN' && (
        <DocumentCard
          type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_KITCHEN}
        />
      )}
      {activePanel.activeSection === 'INTERNAL_SLEEPING_AREA' && (
        <DocumentCard
          type={DocumentFormEnum.DETAILS_VEHICLE_INTERNAL_SLEEPING_AREA}
        />
      )}
      {activePanel.activeSection === 'OPERATING_HOURS' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_VEHICLE_OPERATING_HOURS} />
      )}
      {activePanel.activeSection === 'MARINE_FRONT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_FRONT} />
      )}
      {activePanel.activeSection === 'MARINE_BACK' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_BACK} />
      )}
      {activePanel.activeSection === 'MARINE_LEFT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_LEFT} />
      )}
      {activePanel.activeSection === 'MARINE_RIGHT' && (
        <DocumentCard type={DocumentFormEnum.DETAILS_MARINE_RIGHT} />
      )}
      {activePanel.activeSection === 'SALE_DETAILS' && <SalePriceCard />}
      {SECURITY_CHECK_LIST[1].includes(activePanel.activeSection) && (
        <NevdisCheckCard
          type={activePanel.activeSection as DocumentFormType}
          data={securityCheckData}
          status={securityCheckStatus}
        />
      )}
    </>
  );
};

export default VehicleDetails;
